import {gql} from '@apollo/client';
import {useEffect, useState} from 'react';
import {useDjangoContext} from '../contexts/useAuthContext';
import {GetAllStaff_allStaff} from '../schema-types/GetAllStaff';
import {useLocalStorage} from './useLocalStorage';

export type selectedStaff = Pick<GetAllStaff_allStaff, 'id' | 'name'>;

export const getStaffIdQuery = gql`
  query GetStaffIdOfUser {
    getCurrentUser {
      id
      curoId
      name
      isAdviser
      isAdministrator
      isServiceManager
      isSupervisor
      isParaplanner
      isCaseChecker
      isDeleted
      isUserDev
      isUserTester
      businessUnit {
        id
        name
      }
    }
  }
`;

export const useGetStaffId = () => {
  const [showStaff, setShowStaff] = useState(false);
  const {djangoUser} = useDjangoContext();
  const [staff, setStaff] = useLocalStorage<null | selectedStaff>('dashboardStaff', null);

  useEffect(() => {
    if (!staff && djangoUser) {
      setStaff(djangoUser);
    }
  }, [djangoUser]);
  return {
    currentUserData: djangoUser,
    staff,
    setStaff,
    setShowStaff,
    showStaff,
  };
};
